import { render, staticRenderFns } from "./SelectMetaList.vue?vue&type=template&id=6ba8e540&lang=pug"
import script from "./SelectMetaList.vue?vue&type=script&lang=js"
export * from "./SelectMetaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports